import { render, staticRenderFns } from "./step-card-oralb.vue?vue&type=template&id=7d0a4df6&scoped=true"
import script from "./step-card-oralb.vue?vue&type=script&lang=js"
export * from "./step-card-oralb.vue?vue&type=script&lang=js"
import style0 from "./step-card-oralb.vue?vue&type=style&index=0&id=7d0a4df6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0a4df6",
  null
  
)

export default component.exports